import * as Types from '../../../generated/webapp_gql';

import { ScreenSectionFragment, ContentLink_AssessmentLinkNode_Fragment, ContentLink_CircleSeriesLinkNode_Fragment, ContentLink_CircleSessionLinkNode_Fragment, ContentLink_CircleTopicLinkNode_Fragment, ContentLink_CourseLinkNode_Fragment, ContentLink_ExternalLinkNode_Fragment, ContentLink_HrEventLinkNode_Fragment, ContentLink_HrResourceLinkNode_Fragment, ContentLink_InternalLinkNode_Fragment, ContentLink_MeditationLinkNode_Fragment, ContentLink_ProgramLinkNode_Fragment, ContentLink_ScreenLinkNode_Fragment } from '../../dashboard/documents/getHomeScreen.generated';
import { ProgramPreviewFragment } from '../../newPrograms/documents/getProgram.generated';
import { gql } from 'graphql.macro';
import { ScreenSectionFragmentDoc, ContentLinkFragmentDoc } from '../../dashboard/documents/getHomeScreen.generated';
import { ProgramPreviewFragmentDoc } from '../../newPrograms/documents/getProgram.generated';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
const defaultOptions =  {}
export type ResourcesScreenFragment = (
  { __typename?: 'ResourcesScreenNode' }
  & Pick<Types.ResourcesScreenNode, 'id' | 'uuid' | 'name' | 'platform'>
  & { screenSections: Array<(
    { __typename?: 'ScreenSectionNode' }
    & Pick<Types.ScreenSectionNode, 'id'>
    & ScreenSectionFragment
  )> }
);

export type GetResourcesPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetResourcesPageQuery = (
  { __typename?: 'Query' }
  & { resourcesScreen?: Types.Maybe<(
    { __typename?: 'ResourcesScreenNode' }
    & Pick<Types.ResourcesScreenNode, 'id'>
    & ResourcesScreenFragment
  )> }
);

export const ResourcesScreenFragmentDoc = gql`
    fragment ResourcesScreen on ResourcesScreenNode {
  id
  uuid
  name
  platform
  screenSections {
    id
    ...ScreenSection
  }
}
    ${ScreenSectionFragmentDoc}`;
export const GetResourcesPageDocument = gql`
    query getResourcesPage {
  resourcesScreen(platform: WEB) {
    id
    ...ResourcesScreen
  }
}
    ${ResourcesScreenFragmentDoc}
${ScreenSectionFragmentDoc}
${ContentLinkFragmentDoc}
${ProgramPreviewFragmentDoc}`;

/**
 * __useGetResourcesPageQuery__
 *
 * To run a query within a React component, call `useGetResourcesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResourcesPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetResourcesPageQuery, GetResourcesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetResourcesPageQuery, GetResourcesPageQueryVariables>(GetResourcesPageDocument, options);
      }
export function useGetResourcesPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetResourcesPageQuery, GetResourcesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetResourcesPageQuery, GetResourcesPageQueryVariables>(GetResourcesPageDocument, options);
        }
export type GetResourcesPageQueryHookResult = ReturnType<typeof useGetResourcesPageQuery>;
export type GetResourcesPageLazyQueryHookResult = ReturnType<typeof useGetResourcesPageLazyQuery>;
export type GetResourcesPageQueryResult = ApolloReactCommon.QueryResult<GetResourcesPageQuery, GetResourcesPageQueryVariables>;